export default __webpack_public_path__ + "static/media/chevron-right-outline.5c473ccc.svg";